import type { CellContext } from '@tanstack/react-table'

import { HighlightText } from '@/components/ui/table/DataTable/HighlightText'
import { numberToCurrency } from '@/utils'

export const AmountCell = <TData, TValue>(
  cell: CellContext<TData, TValue>,
): React.ReactNode => {
  const amount = cell.getValue() as number
  const isNegative = amount < 0
  const searchQuery = cell.table.options.meta?.searchQuery
  const formatted = numberToCurrency(amount)

  return (
    <span
      className={`block truncate font-normal ${isNegative ? 'text-red-600' : 'text-emerald-500'}`}
    >
      <HighlightText text={formatted} query={searchQuery} />
    </span>
  )
}
